import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { RefreshCcw, AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            minHeight: '400px',
            padding: '40px',
            textAlign: 'center',
            background: 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(10px)',
            borderRadius: '24px',
            margin: '20px',
            border: '1px solid rgba(239, 68, 68, 0.2)',
            boxShadow: '0 20px 40px rgba(0,0,0,0.05)'
          }}
        >
          <Box 
            sx={{ 
              width: '80px', 
              height: '80px', 
              borderRadius: '20px', 
              background: 'rgba(239, 68, 68, 0.1)', 
              color: '#ef4444', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              marginBottom: '24px'
            }}
          >
            <AlertTriangle size={40} />
          </Box>
          
          <Typography variant="h4" sx={{ fontWeight: 800, color: '#1e293b', marginBottom: '12px' }}>
            Something went wrong
          </Typography>
          
          <Typography sx={{ color: '#64748b', marginBottom: '32px', maxWidth: '400px' }}>
            We encountered an unexpected error while rendering this section. Don't worry, your data is safe.
          </Typography>

          <Button 
            variant="contained" 
            onClick={this.handleReset}
            startIcon={<RefreshCcw size={18} />}
            sx={{ 
              borderRadius: '12px', 
              padding: '12px 24px', 
              textTransform: 'none', 
              fontWeight: 700,
              boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
              background: '#1e293b',
              '&:hover': { background: '#0f172a' }
            }}
          >
            Reload Component
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
